/* import __COLOCATED_TEMPLATE__ from './tag-row.hbs.js'; */
import { classNames } from "@ember-decorators/component";
import discourseComputed from "discourse/lib/decorators";
import SelectKitRowComponent from "select-kit/components/select-kit/select-kit-row";
const TagRow = dt7948.c(class TagRow extends SelectKitRowComponent {
  isTag(item) {
    return item.id !== "no-tags" && item.id !== "all-tags";
  }
  static {
    dt7948.n(this.prototype, "isTag", [discourseComputed("item")]);
  }
}, [classNames("tag-row")]);
export default TagRow;